module.exports = __webpack_public_path__ + "static/img/robot-ul.89abaa9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/robot-ul.png
// module id = Pj/1
// module chunks = 1